import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Input from '../Elements/Input/Input';
import Button from '../Elements/Button/Button';
import Select from '../Elements/Select/Select';
import { changeAddressInput, register } from '../../actions/checkout';
import { addressFieldOrder } from '../../config';
import { translate } from '../../utils/locale';
import { fieldValidation, upperCaseFirst } from '../../utils/string';
import s from './Account.scss';

const Register = ({ setup, checkout, toggleView, ...props }) => {
	const [errors, updateErrors] = useState({});
	const countries = Object.keys(setup.countries).filter((country) => setup.countries[country].shipTo).reduce((acc, country) => (country !== '0' ? [...acc, { key: country, value: setup.countries[country].name }] : [...acc]), []);
	const states = setup.countries[setup.country].states ? Object.keys(setup.countries[setup.country].states).map((state) => ({ key: state, value: setup.countries[setup.country].states[state] })) : null;

	const onAddressInputChange = (id, value) => {
		id = id.replace('address-', '');
		props.changeAddressInput('address', id, value);
		updateErrors((prevState) => {
			const { [id]: removed, ...nextState } = prevState;
			return nextState;
		});
	};

	const onAddressInputBlur = (id, value) => {
		id = id.replace('address-', '');
		onAddressInputChange(id, value);

		if (id === 'passwordRepeat' && checkout.payment.address.password !== checkout.payment.address.passwordRepeat) {
			updateErrors((prevState) => ({
				...prevState,
				passwordRepeat: translate(setup, 'errorPasswordNoMatch'),
			}));
		}

		if (fieldValidation(value, id)) {
			updateErrors((prevState) => ({
				...prevState,
				[id]: translate(setup, `error${fieldValidation(value, id)}`),
			}));
		}
	};

	const onRegister = (e) => {
		e.preventDefault();

		// Ensure that we are using data from the fields as it may be autofilled.
		const $inputs = e.currentTarget.querySelectorAll('input');
		$inputs.forEach(($input) => {
			const id = $input.getAttribute('id');
			const value = $input.value;
			onAddressInputBlur(id, value);
		});

		// Ensure that we are using data from the fields as it may be autofilled.
		const $selects = e.currentTarget.querySelectorAll('select');
		$selects.forEach(($select) => {
			const id = $select.getAttribute('id');
			const value = $select.value;
			onAddressInputBlur(id, value);
		});

		if (Object.keys(errors).length > 0) return;

		props.register().then(() => {
			window.scrollTo(0, 0);
			return 1;
		}).catch(() => { console.log('DEBUG: did not scroll to top on register.'); });
	};

	return (
		<div className={s.unauthenticated}>
			<form className={s.unauthenticated_inner} onSubmit={onRegister}>
				<div className={s.unauthenticated_inner_fields}>
					{
						[...addressFieldOrder, 'password', 'passwordRepeat'].map((field) => {
							if (field === 'company') return null;
							if (field === 'country') {
								return <Select key={`address-${field}`} id={`address-${field}`} isError={errors[field] || false} selected={setup.country} options={[{ key: '', value: translate(setup, 'chooseCountry') }, ...countries]} label={translate(setup, `label${upperCaseFirst(field)}`)} inputChange={onAddressInputChange} inputBlur={onAddressInputBlur} />;
							}
							if (field === 'state') {
								if (states) {
									return <Select key={`address-${field}`} id={`address-${field}`} isError={errors[field] || false} selected={checkout.payment.address[field]} options={[{ key: '', value: translate(setup, 'chooseState') }, ...states]} label={translate(setup, `label${upperCaseFirst(field)}`)} inputChange={onAddressInputChange} inputBlur={onAddressInputBlur} />;
								}
								return null;
							}
							const fieldEvents = {
								inputChange: onAddressInputChange,
								inputBlur: onAddressInputBlur,
							};
							let fieldType = 'text';
							if (field === 'email') fieldType = 'email';
							if (field === 'phoneNumber') fieldType = 'tel';
							if (field.indexOf('password') !== -1) fieldType = 'password';

							return <Input key={`address-${field}`} id={`address-${field}`} isError={errors[field] || false} type={fieldType} value={checkout.payment.address[field]} label={translate(setup, `label${upperCaseFirst(field)}`)} {...fieldEvents} />;
						})
					}
				</div>

				{ checkout.selectionErrorRegistered && <p className={s.unauthenticated_inner_error}>{ translate(setup, 'errorAlreadyRegistered') }</p> }
				<Button variantClasses={['button__inverse']} textColor="#FFF5CA" type="submit">{ translate(setup, 'accountRegisterSubmit') }</Button>
				<div className={s.unauthenticated_inner_return}>
					<Button variantClasses={['button__invisible']} type="a" location="#login" clickEventHandler={toggleView}><span>{ translate(setup, 'accountBack') }</span></Button>
					<span className={s.unauthenticated_inner_return_or}>{ translate(setup, 'accountOr') }</span>
					<Button variantClasses={['button__invisible']} type="a" location="#forgot-password" clickEventHandler={toggleView}><span>{ translate(setup, 'accountForgotPassword') }</span></Button>
				</div>
			</form>
		</div>
	);
};

const mapState = (props) => ({ ...props });

export default hot(module)(connect(mapState, { changeAddressInput, register })(Register));
